module.exports = __webpack_public_path__ + "img/cart-instruction-2.72471af2.jpg";